module.exports = __webpack_public_path__ + "img/thailandpost_logo.c21ab7fa.png";